import React from 'react';

const MarketStatsScreen = () => {
	return <div>MarketStatsScreen</div>;
};

export default MarketStatsScreen;
